import React from "react";
import { TabType } from "src/Core/Common/Enums";
import { ITabModel } from "src/Core/ViewModels/settings/Setting";
import AuthenticationQuestions from "../Tabs/General/AuthenticationQuestions/AuthenticationQuestions";
import ContactSupport from "../Tabs/General/ContactSupport";
import { DropOffConfig } from "../Tabs/DropOff/DropOffConfig/DropOffConfig";
import { DropOffUsers } from "../Tabs/DropOff/DropOffUsers/DropOffUsers";
import MessageHistory from "../Tabs/History/MessageHistory";
import MessageOptions from "../Tabs/General/MessageOptions/MessageOptions";
import { TemplateListing } from "../Tabs/Document Request/Templates/TemplateListing";
import MessageNotification from "../Tabs/Notifications/MessageNotification";
import RequestNotification from "../Tabs/Notifications/RequestNotification";
import RequestHistory from "../Tabs/History/RequestHistory";
import DocumentCategory from "../Tabs/Document Request/DocumentCategory";
import "./style.scss";
import { DocumentRequest } from "src/components/RequestDocuments/DocumentRequest";
import ArchiveMessage, { IArchiveMessageProps } from "src/components/Folders/ArchiveMessage";
import { initialFolder } from "src/Core/ViewModels/Folder/FolderModel";
import { MessageEmailTemplate } from "../Tabs/Saved Message/EmailTemplate";
import { RequestEmailTemplate } from "../Tabs/Saved Message/RequestEmailTemplate";
import FolderNotification from "../Tabs/Notifications/FolderNotification";
import ArchiveFiles from "src/components/Folders/ArchiveFiles";

export interface ITabProps {
    tabs: ITabModel[];
    handleTabClick: (type: TabType) => void;
    activeTab: TabType | undefined;
    archiveProps?: IArchiveMessageProps;
    archiveFolder?: number;
}
const defaultMethod = () => {
    //default method
};

const initialArchiveProps: IArchiveMessageProps = {
    folderId: 0,
    folder: initialFolder,
    reload: false,
    handleFolderRefreshClick: defaultMethod,
    isFolderRefresh: false,
    goToParentFolder: defaultMethod
};


const Tab = ({ tabs, handleTabClick, activeTab, archiveProps = initialArchiveProps, archiveFolder }: ITabProps) => {
    const isActiveTab = (tabData: ITabModel): boolean => {
        return tabData.isActive === true;
    };

    const GetTabContent = () => {
        switch (activeTab) {
            case TabType.Configuration:
                return <DropOffConfig />;
            case TabType.User:
                return <DropOffUsers />;
            case TabType.MessageHistory:
                return <MessageHistory />;
            case TabType.RequestHistory:
                return <RequestHistory />;
            case TabType.MessageNotification:
                return <MessageNotification />;
            case TabType.RequestNotification:
                return <RequestNotification />;
            case TabType.FolderNotification:
                return <FolderNotification />;
            case TabType.DocumentCategory:
                return <DocumentCategory />;
            case TabType.RequestTemplate:
                return <TemplateListing />;
            case TabType.SupportContact:
                return <ContactSupport />;
            case TabType.AuthenticationQuestions:
                return <AuthenticationQuestions />;
            case TabType.MessageOption:
                return <MessageOptions />;
            case TabType.ArchiveRequest:
                return <DocumentRequest
                    isArchive={true}
                    folder={archiveProps.folder}
                    goToParentFolder={archiveProps.goToParentFolder} />;
            case TabType.ArchiveMessage:
                return <ArchiveMessage
                    folderId={archiveProps.folderId}
                    folder={archiveProps.folder}
                    reload={archiveProps.reload}
                    handleFolderRefreshClick={archiveProps.handleFolderRefreshClick}
                    isFolderRefresh={archiveProps.isFolderRefresh}
                />;
            case TabType.ArchiveFiles:
                return <ArchiveFiles folderId={archiveProps.folderId}
                    folder={archiveProps.folder} />;
            case TabType.MessageEmailTemplate:
                return <MessageEmailTemplate />;
            case TabType.RequestsEmailTemplate:
                return <RequestEmailTemplate />;
        }
    };

    return (
        <div className="tab-container">
            <div className="tab-header-container">
                <div className="tab-header-wrapper">
                    {tabs.map((tab, index) => (
                        <div key={index} className={isActiveTab(tab) == true ? "tab-active" : ""}>
                            <div className="tab-wrapper">
                                <p
                                    className={isActiveTab(tab) == true ? "tab-selected" : "tab-default"}
                                    onClick={() => handleTabClick(tab.type)}
                                >
                                    {tab.title}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="tab-content">{GetTabContent()}</div>
        </div>
    );
};

export default Tab;
